import axios from "axios";

export default {
  namespaced: true,
  state: {
    payrolls: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    currentEmployeeId: null,
  },
  mutations: {
    RECEIVED_PAYROLLS(state, payload) {
      state.payrolls = payload;
      state.isReceiving = false;
    },
    RECEIVING_PAYROLLS(state) {
      state.isReceiving = true;
    },
    RECEIVED_DATA(state, payload) {
      console.log(payload)
      let payroll  = state.payrolls.find(item=>item._id==payload.payrollid);
      
      console.log(payroll)
      if(payroll!=null) {
        payroll.data = payload;
        payroll.isData = 'Yes';
      }
      console.log("refres", state.payrolls)
    },
    RECEIVED_PAYROLL(state, payload) {
      state = Object.assign(state, {
        payrolls: [...state.payrolls, payload],
        isReceiving: false,
        currentEmployeeId: payload.employeeid,
      })
    },
    RECEIVING_PAYROLL(state) {
      state.isReceiving = true;
    },
    UPDATED_PAYROLL(state, payload) {
      state.currentEmployeeId = payload._id;
      let index = state.payrolls.findIndex(payroll => payroll._id === payload._id);
      state = Object.assign(state, {
        payrolls: state.payrolls.map((payroll, i) => {
          if (i === index) {
            return Object.assign({}, payroll, payload);
          }
          return payroll;
        }),
        isUpdating: false,
        payrollsMessage: 'Payrolls has been updating!',
      })
    },
    UPDATING_PAYROLL(state) {
      state.isUpdating = true;
    },
    DELETED_PAYROLL(state, payload) {
      let indexToDelete = state.payrolls.findIndex(payroll => payroll._id === payload._id);
      console.log(indexToDelete);
      let payrolls = [...state.payrolls];
      payrolls.splice(indexToDelete, 1);
      state = Object.assign(state, {
        payrolls: [...payrolls],
        isDeleting: false,
        idToDelete: null,
        payrollsMessage: 'Payroll has been Deleted!',
      });
    },
    DELETING_PAYROLL(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    setCurrentEmployeeId({dispatch}, id){
      dispatch("updatedCurrentEmployeeId",id);
    },
    async getPayrollsRequest({dispatch}) {
      dispatch("receivingPayrolls");
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/get/payrolls';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "GET", url: url, headers: headers});
      dispatch("receivePayrolls", response.data);
      return response.data;
    },
    async insertExportData({commit}, payload) {
      commit("RECEIVED_DATA", payload)
    },
    updatePayrollRequest({dispatch}, payload) {
      let id = payload._id;
      delete payload['_id'];
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/update/payroll/changestatus/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "PUT", url: url, headers: headers, data: payload})
      .then(function (res) {
        dispatch("updatedPayroll", res.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updatePayrollPendingRequest({dispatch}, payload) {
      dispatch("updatingPayroll");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.accountxc.com:3100/update/payroll/pending/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updatePayroll", response.data);
      return response.data;
    },
    async insertPayroll({dispatch}, payload) {
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/run/payroll';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      return axios({method: "POST", url: url, headers: headers, data: payload})
      .then((response) =>{
        dispatch("receivedPayroll", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    deletePayrollRequest({dispatch}, payload) {
      dispatch("deletingPayroll", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/delete/payroll/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers})
      .then((response) => {
        console.log(response)
        dispatch("deletedPayroll", {_id: response.data._id});
      })
    },
    async emailPayrollRequest({dispatch}, payload) {
      dispatch("updatingPayroll", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.accountxc.com:3100/email/payroll/' + payload._id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      let response = await axios({method: "POST", url: url, headers: headers});
      return response.data;
    },
    receivePayrolls({commit}, payload) {
      commit("RECEIVED_PAYROLLS", payload)
    },
    receivingPayrolls({commit}) {
      commit("RECEIVING_PAYROLLS")
    },
    receivedPayroll({commit}, payload) {
      commit("RECEIVED_PAYROLL", payload)
    },
    receivingPayroll({commit}) {
      commit("RECEIVING_PAYROLL")
    },
    updatePayroll({commit}, payload) {
      commit("UPDATED_PAYROLL", payload)
    },
    updatingPayroll({commit}) {
      commit("UPDATING_PAYROLL")
    },
    deletedPayroll({commit}, payload) {
      commit("DELETED_PAYROLL", payload)
    },
    deletingPayroll({commit}, payload) {
      commit("DELETING_PAYROLL", payload)
    }
  },
};
